/**
 * 時間前市場 約定履歴 (ティッカー) 取得 hook。
 */
import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listBiddingMarketContracts } from '@ebalance/proto/bffuser/v1/bidding_intraday_market_service-BiddingIntradayMarketService_connectquery'
import {
  ListBiddingMarketContractsRequestSchema,
  type ListBiddingMarketContractsResponse,
} from '@ebalance/proto/bffuser/v1/bidding_intraday_market_service_pb'
import type { Date as ProtoDate } from '@ebalance/proto/google/type/date_pb'
import type { UseQueryResult } from '@tanstack/react-query'

import { TICKER_ESTIMATE_REFETCH_INTERVAL_MS } from '~/pages/IntradayBidding/constants/market'

/**
 * `autoRefresh` が ON の間は、 推定エリア・売買区分の書き換えを拾うため一定間隔で取り直す
 * (AC-BIN-031)。 OFF の間は表示中の行を書き換えないよう取り直さない (取得失敗の再試行も、
 * 一度も取得できていない時だけ続ける)。
 */
export function useMarketContracts(
  deliveryDate: ProtoDate | undefined,
  timeCode: number,
  enabled: boolean,
  autoRefresh: boolean,
): UseQueryResult<ListBiddingMarketContractsResponse, ConnectError> {
  return useQuery(
    listBiddingMarketContracts,
    create(ListBiddingMarketContractsRequestSchema, {
      deliveryDate,
      timeCode,
    }),
    {
      enabled: enabled && deliveryDate !== undefined && timeCode > 0,
      staleTime: Infinity,
      // backend gRPC 未接続でも error boundary に飛ばさず、 呼び出し側でローディング表示。
      throwOnError: false,
      refetchInterval: (query) => {
        if (query.state.status === 'error') {
          return autoRefresh || query.state.data === undefined ? 5000 : false
        }
        return autoRefresh ? TICKER_ESTIMATE_REFETCH_INTERVAL_MS : false
      },
    },
  )
}
